import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const ChatEmpty = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h6" sx={{ color: '#aebac1' }}>
            Selecciona un chat para empezar a chatear
        </Typography>
    </Box>
  )
}
